import { z } from 'zod';

import { MantineThemeColors } from '#lib/colors';

type ColorType = (typeof MantineThemeColors)[number];

function isValidColor(color: string): color is ColorType {
  return MantineThemeColors.some((value) => value === color);
}

export const ColorSchema: z.ZodType<string | ColorType> = z.enum(MantineThemeColors);
// .transform((val): ColorType => {
//   if (!isValidColor(val)) {
//     console.warn(`Received invalid color: '${val}'`);
//     return 'blue';
//   }
//   return val;
// })
// .refine((val): val is ColorType => true);

export type ColorSchema = z.infer<typeof ColorSchema>;
